"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatPhoneByPassedMask = formatPhoneByPassedMask;
const DIGIT_OR_OBFUSCATE_CHAR = /[*#]/;
function formatPhoneByPassedMask(phone, phoneMask) {
    let phoneIndex = 0;
    let formattedPhone = '';
    for (const maskChar of phoneMask) {
        const isNumber = maskChar !== '#';
        if (phoneIndex > phone.length) {
            break;
        }
        formattedPhone += isNumber ? maskChar : phone[phoneIndex];
        if (DIGIT_OR_OBFUSCATE_CHAR.test(maskChar)) {
            phoneIndex++;
        }
    }
    return formattedPhone;
}
//# sourceMappingURL=utils.js.map